import React, {useState} from 'react';
import {Avatar, Button, Container, Grid, Image, Modal, Row, Spacer, Table, Text} from "@nextui-org/react";
import {projects} from "../core/Projects";
import {Project, Technologies} from "../api/Project";

function Work() {
    const [project, setProject] = useState<Project>();

    function openLink(url: string) {
        window.open(url, "_blank", "noopener noreferrer");
    }

    function buildTable(header: string, techs: string[] | undefined): any {
        if (techs === undefined) {
            return undefined;
        }
        return (
            <Table>
                <Table.Header>
                    <Table.Column>
                        <Text h5>{header}</Text>
                    </Table.Column>
                </Table.Header>
                <Table.Body>
                    {techs.map((tech, index) =>
                        <Table.Row key={index}>
                            <Table.Cell>
                                <Text>{tech}</Text>
                            </Table.Cell>
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        );
    }

    function buildTechnologiesTable(techs?: Technologies): any {
        let res: any = [];
        if (techs?.frontend !== undefined) {
            res.push(buildTable('Frontend Technologies', techs.frontend));
        }
        if (techs?.backend !== undefined) {
            res.push(buildTable('Backend Technologies', techs.backend));
        }
        return res;
    }

    function buildTechnologies(project: Project) {
        let techs = '| ';
        if (project.technologies.frontend) {
            project.technologies.frontend.forEach(tech => {
                techs += tech + ' | ';
            });
        }
        if (project.technologies.backend) {
            project.technologies.backend.forEach(tech => {
                techs += tech + ' | ';
            });
        }
        return techs;
    }

    return (
        <Container fluid>
            <Spacer y={5}/>
            {projects.filter((project) => !project.hidden)
                .sort((a, b) => b.id - a.id)
                .map((project, idx) =>
                    <Row key={project.id} className={'item'}>
                        <Grid.Container gap={5} justify={'center'}>
                            <Grid xs={2} justify={'center'}>
                                {idx % 2 !== 0 ? null : (
                                    <Avatar css={{size: '$20'}} src={project.image} zoomed/>
                                )}
                            </Grid>
                            <Grid>
                                <Text h3 css={{color: '#999999'}}>{project.title}</Text>
                                <Text h5 css={{color: '#999999', maxWidth: '450px'}}>{buildTechnologies(project)}</Text>
                                <Grid.Container gap={3}>
                                    <Grid>
                                        <Button ghost shadow color={'warning'} onPress={() => openLink(project.link)}>
                                            Visit Project
                                        </Button>
                                    </Grid>
                                    <Grid>
                                        <Button ghost shadow color={'success'} onPress={() => setProject(project)}>
                                            View Details
                                        </Button>
                                    </Grid>
                                </Grid.Container>
                            </Grid>
                            <Grid xs={2} justify={'center'}>
                                {idx % 2 === 0 ? null : (
                                    <Avatar css={{size: '$20'}} src={project.image} zoomed/>
                                )}
                            </Grid>
                        </Grid.Container>
                    </Row>
                )
            }
            <Modal closeButton={true} blur={true} width={'50%'}
                   onClose={() => setTimeout(() => setProject(undefined), 100)}
                   open={project !== undefined}>
                <Modal.Header>
                    <Text h2>{project?.title}</Text>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Image width={80} src={project?.image ?? ''}/>
                    </Row>
                    <Grid.Container gap={2}>
                        <Grid xs={1}>
                            <Text>About:</Text>
                        </Grid>
                        <Grid xs={11}>
                            <Text css={{color: '#e83e8c'}}>{project?.description}</Text>
                        </Grid>
                    </Grid.Container>
                    <Grid.Container gap={2}>
                        <Grid xs={2}>
                            <Text>Start Date:</Text>
                        </Grid>
                        <Grid xs={4} justify={'flex-start'}>
                            <Text css={{color: '#e83e8c'}}>{project?.startDate}</Text>
                        </Grid>
                        <Grid xs={2} justify={'flex-end'}>
                            <Text>End Date:</Text>
                        </Grid>
                        <Grid xs={4} justify={'flex-start'}>
                            <Text css={{color: '#e83e8c'}}>{project?.completeDate}</Text>
                        </Grid>
                    </Grid.Container>
                    <Grid.Container gap={4}>
                        {buildTechnologiesTable(project?.technologies).map((comp: any, idx: number) =>
                            <Grid xs={6} key={idx} justify={'center'}>{comp}</Grid>
                        )}
                    </Grid.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button shadow color={'success'} onPress={() => openLink(project?.link!)}>
                        Visit Project
                    </Button>
                    <Button shadow color={'error'} onPress={() => setProject(undefined)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}

export default Work;